// import intl from 'react-intl-universal';
import moment from 'moment';
import { DATE_FORMATS } from 'src/constants/constants';

const DISPLAY_DATE_ONLY = DATE_FORMATS.DISPLAY_DATE_ONLY;
const ISO8601_DATE = DATE_FORMATS.ISO8601_DATE;
const ISO8601_DATE_TIME = DATE_FORMATS.ISO8601_DATE_TIME;

export function diffDays(ts1, ts2) {
  return moment(ts1, ISO8601_DATE).diff(moment(ts2, ISO8601_DATE), 'days');
}

export function toMoment(ts) {
  let momentObj = moment(ts, ISO8601_DATE_TIME);
  if (momentObj.isValid()) return momentObj;

  momentObj = moment(ts, ISO8601_DATE);
  if (momentObj.isValid()) return momentObj;

  momentObj = moment(ts, DISPLAY_DATE_ONLY);
  if (momentObj.isValid()) return momentObj;

  return momentObj;
}

export function formatDate(ts, format = ISO8601_DATE) {
  return ts ? moment(ts, format).format(DISPLAY_DATE_ONLY) : '';
}

export function formatDateTime(ts, format = ISO8601_DATE_TIME) {
  if (!ts) return '';

  const momentObj = moment(ts, format);
  const dateFormatted = momentObj.format(DISPLAY_DATE_ONLY);
  const day = momentObj.format('dddd');
  const noon = 12;
  const hours = momentObj.get('hour');

  let meridiem = 'am';

  const differenceInDays = diffDays(moment().toISOString(), ts);

  if (hours >= noon) {
    meridiem = 'pm';
  }

  const timeFormatted = momentObj.format('hh:mm') + meridiem;

  if (differenceInDays >= 0 && differenceInDays < 1) {
    return `${timeFormatted}`;
  }

  if (differenceInDays >= 1 && differenceInDays < 2) {
    return `Yesterday, ${timeFormatted}`;
  }

  if (differenceInDays >= 2 && differenceInDays < 7) {
    return `${day}, ${timeFormatted}`;
  }

  if (differenceInDays >= 7 && differenceInDays < 365) {
    return `${dateFormatted}`;
  }

  return `${dateFormatted}, ${timeFormatted}`;
}

export function formatReplyDate(ts, format = ISO8601_DATE_TIME) {
  if (!ts) return '';

  const momentObj = moment(ts, format);
  const dateFormatted = momentObj.format(DISPLAY_DATE_ONLY);
  const noon = 12;
  const hours = momentObj.get('hour');
  let meridiem = 'am';

  if (hours >= noon) {
    meridiem = 'pm';
  }

  const timeFormatted = momentObj.format('hh:mm') + meridiem;

  return `${dateFormatted} at ${timeFormatted}`;
}

export function formatDateAndTime(ts, format = ISO8601_DATE_TIME) {
  if (!ts) return '';

  const momentObj = moment(ts, format);
  const dateFormatted = momentObj.format(DISPLAY_DATE_ONLY);
  const noon = 12;
  const hours = momentObj.get('hour');
  let meridiem = 'am';

  if (hours >= noon) {
    meridiem = 'pm';
  }

  const timeFormatted = momentObj.format('hh:mm') + meridiem;

  return `${dateFormatted}, ${timeFormatted}`;
}

export function getTodaysDate() {
  return moment().format(DISPLAY_DATE_ONLY);
}

export function addDays(days) {
  var result = new Date();
  result.setDate(result.getDate() + days);
  return result;
}
